<script>
    import { _deleteUser } from "../../firebase/auth";
    import { navigate } from "svelte-routing";
    import CurrentPassword from "../../components/passwords/CurrentPassword.svelte";
    import AuthError from "../../components/auth/AuthError.svelte";
    import Input from "../../components/Input.svelte";
    import ButtonPrimary from "../../components/ButtonPrimary.svelte";
    
    let currentPassword;
    let errorCode;

    function deleteUser () {
        errorCode = undefined;
        _deleteUser(currentPassword)
        .then(() => {
            currentPassword = undefined;
            alert("Dein Account wurde erfolgreich gelöscht");
            navigate("/");
        })
        .catch((error) => {
            errorCode = error.code;
        })
    }
</script>

<div class="form">
    <h1>Account löschen</h1>
    <div class="verification-required">
        <span>Das Löschen eines Accounts ist endgültig und kann nicht wieder rückgängig gemacht werden! Fahre nur fort, wenn du dir sicher bist, dass du den Account wirklich löschen möchtest.</span>
    </div>
    <form on:submit|preventDefault={deleteUser}>
        <Input type=password bind:value={currentPassword} label="Passwort"/>
        <div class="actions">
            <ButtonPrimary type="submit" disabled={!currentPassword}>Account löschen</ButtonPrimary>
        </div>
    </form>
    <AuthError errorCode={errorCode}/>
</div>

<style>
    .form {
        max-width: 30rem;
        margin: auto;
    }
    
    .actions {
        display: flex;
        flex-direction: row-reverse;
        justify-content: space-between;
        align-items: center;
        margin-top: 2rem;
    }

    .verification-required {
        margin: 1rem 0;
        border-left: 5px solid rgb(210, 0, 0);
        padding: 0.5rem 1rem;
        background-color: rgb(255, 210, 210);
    }
</style>